module.exports = __webpack_public_path__ + "img/freetour.c47aebbf.svg";